import React from 'react';
import { useEffect, useState } from 'react';
import { FcCollapse } from 'react-icons/fc';
const { useTranslation } = require('react-i18next');

const BoxLayouAccount = ({
  boxTitle,
  hidden,
  collapsible,
  children,
  setUpdateStep,
}) => {
  const [collapsed, setCollapsed] = useState(hidden || false);
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof hidden === 'undefined') return;
    setCollapsed(hidden);
  }, [hidden]);

  const onCollapse = (e) => {
    e.preventDefault();
    if (collapsible) setCollapsed((prevCollapsed) => !prevCollapsed);
    setUpdateStep();
  };
  const display = collapsed ? 'hidden' : 'visible';
  const rotate = collapsed
    ? 'transform rotate-180 transition-all duration-300'
    : 'transition-all duration-300';

  return (
    <>
      {boxTitle.value === 'Partner Information' ||
      boxTitle.value === 'Partner General Questions' ||
      boxTitle.value === 'Partner Income' ||
      boxTitle.value === 'Partner Expenses' ||
      boxTitle.value === 'Partner Investment' ||
      boxTitle.value === 'Partner Employment Expenses' ||
      boxTitle.value === 'Partner Authorize a representative' ||
      boxTitle.value === 'Partner Direct Deposit' ? (
        <div className="border border-blue-gray-100 shadow-sm rounded-xl mb-3 bg-gray-50 ">
          <button
            className={`flex flex-row text-left min-w-full px-4 ${
              collapsed ? '' : 'border-b'
            } ${collapsible ? 'cursor-pointer' : 'cursor-default'}`}
            type="button"
            onClick={onCollapse}
          >
            <div className="flex-1 p-4 text-lg font-extrabold text-blue-900">
              {t(boxTitle.label)}
            </div>
            <FcCollapse size={22} className={`m-4 self-center ${rotate}`} />
          </button>
          <div className={`w-full ${display}`}>{children}</div>
        </div>
      ) : (
        <div className="border border-blue-gray-100 shadow-sm rounded-lg bg-neutral-50 mb-3">
          <button
            className={`flex flex-row text-left min-w-full px-4 ${
              collapsed ? '' : 'border-b'
            } ${collapsible ? 'cursor-pointer' : 'cursor-default'}`}
            type="button"
            onClick={onCollapse}
          >
            <div className="flex-1 p-4 text-lg font-extrabold text-blue-900">
              {t(boxTitle.label)}
            </div>
            <FcCollapse
              size={22}
              className={`m-4 self-center ${rotate}`}
              id={boxTitle.value}
            />
          </button>
          <div className={`w-full ${display}`}>{children}</div>
        </div>
      )}
    </>
  );
};

export default BoxLayouAccount;
